import { Checkbox } from '@/components/shadcn/ui/checkbox';

export default function ShowNewToggle({
  checked,
  onCheckedChange,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer items-center gap-2 text-sm font-medium">
      <Checkbox
        checked={checked}
        onCheckedChange={(nextChecked) =>
          onCheckedChange(nextChecked === true)
        }
      />
      Show new
    </label>
  );
}
